import './gameHeader.scss'
import {
  MusicOffIcon,
  MusicOnIcon,
  ProvableFairIcon,
  VolumeMuteIcon,
  VolumeUnMuteIcon
} from 'assets/icons/index'
import { showToastToLogin } from 'helpers/common.helpers'

import { ReactComponent as SettingsIcon } from './assets/svg/settings.svg'
import { ReactComponent as VolumeIcon } from './assets/svg/volume.svg'
import {
  setGameMusic,
  setGameSound
} from 'redux-store/redux/slices/gameSettings.slice'
import { useDispatch } from 'react-redux'
import { useEffect, useRef, useState } from 'react'
import WalletBalance from '../WalletBalance/index'

const GameHeader = (props) => {
  const {
    handleFairnessModal,
    demoMode,
    gameSound,
    gameMusic
  } = props

  const dispatch = useDispatch()

  const [isSettingsOpen, setIsSettingsOpen] = useState(false)
  const settingsRef = useRef(null)
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        settingsRef.current &&
        !settingsRef.current.contains(event.target)
      ) {
        setIsSettingsOpen(false)
      }
    }
    document.addEventListener('pointerdown', handleOutsideClick, true)
    return () => {
      document.removeEventListener('pointerdown', handleOutsideClick, true)
    }
  }, [])

  return (
    <div className='game-header-col d-flex d-lg-none align-items-center justify-content-between'>

      <div className='header-logo'>
        <img src='../assets/images/common/canvas-gaming-logo.png' />
      </div>

      <div className='header-balance text-center'>
        <WalletBalance />
      </div>

      <ul className='list-inline mb-0 position-relative d-flex align-items-center'>

        <li
          ref={settingsRef}
          className='list-inline-item dropdown position-relative'
        >

          <button
            type='button'
            className='bg-transparent border-0'
            onClick={() => setIsSettingsOpen(prev => !prev)}
          >
            <SettingsIcon />
          </button>

          {isSettingsOpen && (
            <ul
              className='dropdown-menu dropdown-menu-dark show'
              style={{
                position: 'absolute',
                top: '100%',
                right: 0,
                left: 'auto',
                marginTop: '5px'
              }}
            >

              {/* Audio */}
              <li
                className='px-3 mb-3'
                onClick={() => {
                  dispatch(setGameSound(!gameSound))
                }}
              >
                {gameSound
                  ? (
                    <VolumeIcon
                     width={25}
                      height={25}
                      className='dice-footer-icon'
                    />
                    )
                  : (
                    <VolumeUnMuteIcon
                      width={25}
                      height={25}
                      className='dice-footer-icon'
                    />
                    )}

                <span className='ms-2'>Audio</span>
              </li>

              {/* Music */}
              <li
                className='px-3 mb-3'
                onClick={() => {
                  dispatch(setGameMusic(!gameMusic))
                }}
              >
                {gameMusic
                  ? (
                    <MusicOnIcon
                      width={25}
                      height={25}
                      className='dice-footer-icon'
                    />
                    )
                  : (
                    <MusicOffIcon
                      width={25}
                      height={25}
                      className='dice-footer-icon'
                    />
                    )}

                <span className='ms-2'>Music</span>
              </li>

              {/* Fairness */}
              <li
                className='px-3 mb-2'
                onClick={demoMode ? showToastToLogin : handleFairnessModal}
              >
                <ProvableFairIcon className='dice-footer-icon' />

                <span className='ms-2'>Fairness</span>
              </li>

            </ul>
          )}

        </li>

      </ul>
    </div>
  )
}

export default GameHeader
